(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
var lastScrollTop = 50;
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setHeaderHeightLive();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeightLive.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.stickyScrollTop = 400;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderHeightLive(event, zero) {
      document.documentElement.style.setProperty('--header-height-live', `${zero ? 0 : this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      requestAnimationFrame(() => {
        if ((this.predictiveSearch && this.predictiveSearch.isOpen) || Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;
        const scrollDifference = scrollTop - this.currentScrollTop;
        if (
            (scrollDifference > 50 && this.pauseScrollListen !== !0 && scrollTop > this.stickyScrollTop
                ? ((this.pauseScrollListen = !0),
                  this.header.classList.add("scrolling-down"),
                  this.header.classList.remove("scrolling-up"),
                  setTimeout(() => {
                      this.pauseScrollListen = !1;
                  }, 320))
                : scrollDifference < -50 && 
                  this.pauseScrollListen !== !0 &&
                  ((this.pauseScrollListen = !0),
                  this.header.classList.add("scrolling-up"),
                  this.header.classList.remove("scrolling-down"),
                  setTimeout(() => {
                      this.pauseScrollListen = !1;
                  }, 320)),
            scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom)
        ) {
            if ((this.header.classList.add("scrolled-past-header"), this.preventHide)) return;
            requestAnimationFrame(this.hide.bind(this));
        } else
            scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom
                ? (this.header.classList.add("scrolled-past-header"),
                  this.preventReveal
                      ? (window.clearTimeout(this.isScrolling),
                        (this.isScrolling = setTimeout(() => {
                            this.preventReveal = !1;
                        }, 66)),
                        requestAnimationFrame(this.hide.bind(this)))
                      : requestAnimationFrame(this.reveal.bind(this)))
                : scrollTop <= this.headerBounds.top &&
                  (this.header.classList.remove("scrolled-past-header"), this.header.classList.remove("scrolling-down"), this.header.classList.remove("scrolling-up"), requestAnimationFrame(this.reset.bind(this)));
        (this.currentScrollTop = scrollTop), (this.lastScrollTrigger = scrollTop);
      });

      if(scrollTop > this.stickyScrollTop){
        this.header.classList.add('custom-sticky');
      } else {
        this.header.classList.remove('custom-sticky');        
      }

    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, !0);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  // Select all currency form select elements
  var selects = document.querySelectorAll('.shopify-currency-form select');

  // Add an event listener to each select element
  selects.forEach(function(select) {
    select.addEventListener('change', function() {
      // Find the closest parent form and submit it
      var form = this.closest('form');
      if (form) {
        form.submit();
      }
    });
  });



  } catch(e) { console.error(e); }
})();
})();
